import { createWithEqualityFn } from 'zustand/traditional';
import { getClientI18n, setClientLanguage } from '@/lib/i18n/client';
import { DEFAULT_LOCALE, normalizeLocale, type AppLocale } from '@/lib/i18n/locales';

interface LanguageState {
  language: AppLocale;
  setLanguage: (lng: AppLocale) => Promise<void>;
}

const clientI18n = getClientI18n();

const ensureSupported = (lng?: string): AppLocale => {
  if (!lng) {
    return DEFAULT_LOCALE;
  }
  return normalizeLocale(lng);
};

export const useLanguageStore = createWithEqualityFn<LanguageState>()((set) => ({
  language: ensureSupported(clientI18n.resolvedLanguage ?? clientI18n.language),
  setLanguage: async (lng) => {
    const target = ensureSupported(lng);
    await setClientLanguage(target);
    set({ language: target });
  }
}));

clientI18n.on('languageChanged', (lng) => {
  useLanguageStore.setState({ language: ensureSupported(lng) });
});
